<template>
  <div class="section">
    <h1>
      <span class="section-title">Plan</span>
      <span class="section-description">{{ $t('subscription.title') }}</span>
    </h1>
    <div v-if="isApp" class="has-text-weight-bold">
      <p class="margin-bottom-30px">サブスクリプションは Web ブラウザからお申し込みください</p>
      <b-button @click="execCopy('https://hstorage.io/subscription', 'subscription-url-copy-button')"
        class="is-info has-text-weight-bold" id="subscription-url-copy-button"
        data-copy-id="subscription-url-copy-button" rounded>サブスクリプションURLをコピー</b-button>
    </div>
    <Subscription v-else class="section" style="border-radius: 30px;"></Subscription>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useSeoHead } from "@/helpers/seo";
import { defineAsyncComponent } from "vue";

export default {
  name: "SubscriptionPage",
  components: {
    Subscription: defineAsyncComponent(() => import('../components/SubscriptionComponent.vue'))
  },
  data() {
    return {
      isApp: false
    }
  },
  created() {
    // ユーザーエージェントに「HStorage」が含まれているかチェック
    if (navigator && navigator.userAgent && navigator.userAgent.includes('HStorage')) {
      this.isApp = true;
    }

    useSeoHead({
      base: '/subscription',
      locale: this.$i18n.locale,
      title: `${this.$t('subscription.title')} | ${appConfig[this.$i18n.locale].title}`,
      description: appConfig[this.$i18n.locale].description.subscription,
    })
  }
}
</script>
